<template>
<form v-on:submit.prevent="uploadCSV()" class="modal-card">
    <header class="modal-card-head">
        <p class="modal-card-title">
            Add more data to dataset
        </p>
        <button
            type="button"
            class="delete"
            @click="$emit('close')"/>
    </header>
    <section class="modal-card-body">
    <b-field>
            <b-switch
                v-model="addManually"
                passive-type='is-dark'
                type='is-success'>
                {{ addManually ? "Add Manually" : "Upload CSV" }}
            </b-switch>
        </b-field>
    </section>
    <section class="modal-card-body" v-if="addManually">
        
        <b-field label="Dataset name">
            <b-input
                type="text"
                v-model="dataset.name"
                placeholder="Dataset name"
                disabled>
            </b-input>
        </b-field>
        <b-field label="Text">
            <b-input maxlength="900" type="textarea" v-model="manual_data_text"></b-input>
        </b-field>
        <b-field label="Label">
            <b-select placeholder="Select a label" 
                v-model="manual_data_label">
                    <option
                        v-for="option in candidateLabels"
                        :value="option"
                        >
                        {{ option }}
                    </option>
                </b-select>
        </b-field>
        
    </section>
    <section class="modal-card-body" v-else>
        <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false">
        </b-loading>
        
        <div class="title is-6">
            Upload a csv file to get more data
        </div>
        <div class="block">
            Upload more example data (text and labels), which can be uploaded as files in the .csv format and should have at least one column for <b>text</b>.
        </div>
        <!--b-field label="">
            
            <a class="is-link is-small" href="https://firebasestorage.googleapis.com/v0/b/ml-saas.appspot.com/o/datasets%2F5p6YeUwjRr8Wlt5fAbFX%2Fbanking77_curated.csv">
            Click here to download a demo csv file
            </a>
            
        </b-field-->

        <b-field label="Dataset name">
            <b-input
                type="text"
                v-model="dataset.name"
                placeholder="Dataset name"
                disabled>
            </b-input>
        </b-field>
        

        <!--b-field label="Input method">
            <b-radio-button v-model="radioButton"
                native-value="Upload a file"
                type="is-info is-light is-outlined">
                
                <span>Upload a file</span>
            </b-radio-button>

            <b-radio-button v-model="radioButton"
                disabled
                native-value="Connect to a database"
                type="is-info is-light is-outlined">
                <span>Connect to a database</span>
            </b-radio-button>
            
        </b-field-->
        
        <b-field label="Upload a csv file">
        </b-field>
        <b-field class="file"  :class="{'has-name': !!inputFile}">
            <b-upload 
                
                class="file-label"
                v-model="inputFile" 
                drag-drop
                @input="changeInput"
                accept=".csv"
                expanded
                required>
                <center>
                <span class="block" v-if="!inputFile">
                    
                    <center>
                        <h3 class="subtitle is-6">
                            <b-icon class="file-icon" icon="upload"></b-icon> 
                            Click to upload or drop your file here
                        </h3>
                        <br>
                    </center>
                </span>
                <span class="block" v-else>

                    <span class="">
                        <center>
                            <div class="subtitle is-4">
                                {{ inputFile.name }} 
                            </div>
                            <span v-if="(inputFile.size/1024/1024) < 1000.00">
                                {{ (inputFile.size/1024/1024).toFixed(2) }} MB
                            </span>
                            <span v-else>
                                {{ (inputFile.size/1024/1024/1024).toFixed(2) }} GB
                            </span>
                        </center>
                    </span>
                </span>
                </center>
            </b-upload>
        </b-field> 
        
        <b-field label="The csv file already have the labels information?">
            <b-radio v-model="haveLabels"
                name="name"
                native-value="Yes">
                Yes
            </b-radio>
            <b-radio v-model="haveLabels"
                name="name"
                native-value="No">
                No (Next step you will annotate your data)
            </b-radio>
        </b-field>
        
        <span v-if="inputFile!=null">
            
        <b-field :label="`Text: ${(text_col)?'Selected the '+text_col+' column':'Select a column'}`" expand>
            <b-select  placeholder="Select a column"
                v-model="text_col" 
                v-if="columns"
                required
                expanded>
                <option
                    v-for="option in columns"
                    :value="option.field"
                    :key="option.field"
                    >
                    {{ option.field }}
                </option>
            </b-select>
        </b-field>
        <!-- <b-field label="Label method">
            <div class="block">
            <b-radio v-model="isLabelColumn"
                name="name"
                :native-value="true">
                Already on file column
            </b-radio>
            <b-radio v-model="isLabelColumn"
                name="name"
                :native-value="false">
                I want to annotate labels
            </b-radio>
        </div>
            
        </b-field> -->
        <!-- <b-message class="box" v-if="!isLabelColumn">
            
            Please, list the labels:
            <br>
        </b-message> -->
        
        <b-field :label="`Label: ${(label_col)?'Selected the '+label_col+ ' column':'Select a column'}`" v-if="haveLabels == 'Yes'">
            <b-select  placeholder="Select a column"
                v-model="label_col"
                v-if="columns"
                required
                expanded
                >
                <option
                    v-for="option in columns"
                    :value="option.field"
                    :key="option.field" selected>
                    {{ option.field }}
                </option>
            </b-select>
        </b-field>

        <b-field label="Add more labels? (tip: type and press enter)" v-else>
            <b-taginput
                v-model="dataset.labels"
                size="is-large"
                :closable="false"
                >
            </b-taginput>
        </b-field>
        
        </span>     
    </section>
    <footer class="modal-card-foot" v-if="addManually">
        <b-button
            label="Close"
            @click="$emit('close')" />
            <b-button
                tag="button"
                @click="addDataManually()"
                label="Add data"
                type="is-primary"
                expanded/>
    </footer>
    <footer class="modal-card-foot" v-else>
        <b-button
            label="Close"
            @click="$emit('close')" />
        <b-button
        tag="button"
            native-type="submit"
            label="Submit"
            type="is-primary"
            expanded 
            :disabled="inputFile==null"/>
    </footer>
</form>
</template>
<script>
import { uuid } from 'vue-uuid'; 
import Papa from 'papaparse';
import DataFrame from 'dataframe-js';
import crypto from 'crypto';

export default {
  props: ["dataset"],
  components: {  },
  data() {
    return {
        addManually: true,
        manual_data_text: "",
        manual_data_label: false,
        inputFile: null,
        columns: null,
        isLoading: false,
        bigger: false,
        isLabelColumn: true,
        haveLabels: 'No',
        labels: [],
        settings: {
            readOnly: true,
            rowHeaders: true,
            licenseKey: 'non-commercial-and-evaluation'
        },
        radioButton: 'Upload a file',
        sampleDataframe: false,
        datasetName: '',
        isFinished: false,
        selectedDataset: ['A'],
        csv: null,
        label_col: false,
        text_col: false,
        animated: true,
        imageData: null,
        file2: false,
        picture: null,
        files: [],
        uploadValue: 0,
        csv: 1,
        json: 1,
        previewDataset: null,
        isComponentModalActive: false,
        isComponentDatasetEditActive: false,
        formProps: {
            email: 'evan@you.com',
            password: 'testing'
        }
    };
  },
  created() {
    this.$store.dispatch("currentUser");

    if (this.dataset.labels.length) {
        this.candidateLabels = this.dataset.labels.sort((a,b) => a.localeCompare(b))
    } else {
        this.candidateLabels = this.dataset.labelBalance['labels']
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    plans() {
        return this.$store.state.plans
    }
  },
  methods:{
    createDataId(text){
        return crypto.createHash('md5').update(text, 'binary').digest('hex');
    },
    addDataManually(){
        const toCreate = {
            datasetId: this.dataset.id,
            newDataId: this.createDataId(this.manual_data_text),
            create: {
                text: this.manual_data_text,
                label: this.manual_data_label
            }
        }
        console.log(toCreate)
        this.$store.dispatch("createDatasetDocument", 
            toCreate
        );

        this.manual_data_text = ""
    },
    changeInput() {
        this.text_col = false
        this.label_col = false

        this.isLoading = true

        if ((this.inputFile.size/1024/1024) < 600) {
            this.parseToJson(this.inputFile, this.getColumns)
        } else {
            
            this.fakeColumns()
        }
    },
    fakeColumns(){
        this.bigger = true
        let cols = []
        for(let i=0; i<= 5;i++){

            cols.push({
                    field: `${i}`,
                    label: `Column ${i}`
            })

            this.columns = Object.values(cols)
        }

        this.isLoading = false

        this.$buefy.dialog.confirm({
            message: `Ops. You are uploading a large dataset! Great!\n\nWe can't preview the dataset columns here, please select text and label columns as is ordered in file.`,
            //onConfirm: () => this.redirect(datasetId) 
        })
    },
    getColumns(data, filename){
        let header = Object.keys(data[0])
        let cols = []
        for(let i=0; i< header.length;i++){
            if (header[i].length < 1) continue
            
            cols.push({
                    field: header[i],
                    label: header[i]
            })
        }
        this.columns = Object.values(cols)

        this.isLoading = false
    },
    uploadCSV(){

        const inputFileName = this.inputFile.name
        const datasetId = this.dataset.id

        const dataset = {
            datasetId: datasetId,
            filename: inputFileName,
            jsonfilename: inputFileName.replace('csv', 'json'),
            cols: this.columns,
            label: this.label_col,
            text: this.text_col,
            labels: this.dataset.labels
        }

        var newDoc = this.$store.dispatch("increaseDataset",
            dataset
        )

        newDoc.then(uploadId => {
            this.isLoading = true
            this.datasetId = datasetId
            const filepath = `datasets/${datasetId}/files/${uploadId}/${inputFileName}`;
            this.$firebase.storage().ref(filepath).put(this.inputFile).then(
                this.completeConfirm
            )
        })
        // Checking your data. This may take up to one minute, depending on the size of your file.
        // Uploading your file. This may take up to a few minutes, depending on your connection speed.

        
        
    },
    completeConfirm(){
        this.isLoading = false
        this.$buefy.dialog.confirm({
                    message: `Great! Data uploaded.\n\n`,
                    onConfirm: () => this.redirect(this.datasetId) 
        })
    },
    importDataframe(fileurl){
        if ((this.file2.size/1024/1024) < 1000) {
            DataFrame.fromCSV(fileurl).then(df => {
                    
                var columns = df.listColumns()
                
                var new_columns = []

                for(var i=0; i<columns.length; i++){
                    if (columns[i] == "") {
                        columns[i] = "col "+ i
                    }
                    new_columns.push({
                        field: columns[i],
                        label: columns[i]
                    })
                }

                this.text_col = columns[i-2]
                this.label_col = columns[i-1]

                const dataset = {
                    data: false, //df.sample(0.1).toCollection().slice(1,4),
                    columns: new_columns
                }

                this.dataframe = df
                this.columns = new_columns

                this.previewDataset = dataset
            })
        } else {

            const dataset = {
                    data: false, 
                    columns: false
            }

            this.previewDataset = dataset

        }

        

    },
    openLoading() {
            let isFullPage = true
            const loadingComponent = this.$buefy.loading.open({
                container: isFullPage ? null : this.$refs.element.$el
            })
            setTimeout(() => loadingComponent.close(), 3 * 1000)
    },
    
    saveToStorage(datasetId, datasetFilename, datasetJson){

      const datasetToJson = JSON.stringify(datasetJson)

      const filepath3 = `datasets/${datasetId}/files${datasetFilename}`
      const storageRef3=this.$firebase.storage().ref(filepath3).put(this.file2);

      if (datasetJson!=null){
        const filepath2 = `datasets/${datasetId}/files/${datasetFilename.replace('csv', 'json')}`
        
        const metadata = {
            contentType: "application/json",
        }

        var blob = new Blob([datasetToJson], {type: "application/json"})
        // const storageRef2=firebase.storage().ref(filepath2).put(datasetToJson, metadata);

        const storageRef2=this.$firebase.storage().ref(filepath2).put(blob);
      }
      


    },
    upload(){
      
      if ((this.file2.size/1024/1024) < 1000) {

        this.parseToJson(this.file2, this.uploadDatasetJson)

      } else {
        const json = null;
        const filename = this.file2.name
        this.uploadDatasetJson(json, filename)

      }

      this.openLoading()

    },
    uploadDatasetJson(datasetJson, datasetFilename){

        var json = datasetJson
            
        var tokens = 0
        var instances = json.length
        
        var new_columns = this.columns
        var labelBalance = null
        var dataframe = this.dataframe

        if (datasetJson != null && (this.file2.size/1024/1024) < 100){
            
            var dataframe = this.dataframe.dropDuplicates(this.text_col).dropMissingValues([this.text_col])
            
            // var newDf = dataframe_distinct.groupBy(this.label_col).aggregate(group => group.count()).rename('aggregation', 'count')

            
            var duplicates = dataframe.count() - this.dataframe.count()

            var jsondata = dataframe.select(this.text_col).toCollection()

            if (this.text_col != null && jsondata != null){
                for(var i=0; i < jsondata.length; i++) {
                    
                    if( jsondata[i][this.text_col]!== undefined ){
                        
                        tokens += jsondata[i][this.text_col].split(" ").length

                    }
                }
            }
        }

        const dataset = {
            //json: this.dataframe.toCollection(),
            name: this.datasetName,
            filename: datasetFilename,
            jsonfilename: datasetFilename.replace('csv', 'json'),
            cols: new_columns,
            tokens: tokens,
            labelBalance: labelBalance,
            instances: instances,
            label: this.label_col,
            text: this.text_col
        }

        var newDoc = this.$store.dispatch("createDataset",
            dataset
        )

        newDoc.then(datasetId => {
            
            if (datasetJson!=null){
                this.saveToStorage(datasetId, datasetFilename, dataframe.toCollection())
            } else {
                this.saveToStorage(datasetId, datasetFilename, false)
            }
            

            setTimeout(() => 
                function(){}, 
                4 * 1000)

            

            this.$buefy.dialog.confirm({
                    message: `We uploaded your dataset.\n\ntokens: ${tokens}\ninstances: ${instances}\nduplicates: ${duplicates}`,
                    onConfirm: () => this.redirect(datasetId) 
            })

            
        })

        // this.$store.dispatch("retrieveAllDatasets");
        

        

        // this.$buefy.notification.open('Uploaded the dataset, '+tokens+' tokens.')

        

    },
    redirect(datasetId){

            this.$buefy.toast.open('Updating dataset')
            
            setTimeout(() => 
                this.$router.push(`/datasets/${datasetId}`), 
                2 * 1000)
    },
    parseToJson(dataFile, callback){
        console.log(dataFile)
        Papa.parse(dataFile, {
            header: true,
            complete: function(results) {
                callback(results.data, dataFile.name);
            }
        })
        
    },
    downloadFile(dataUrl, callback){

        Papa.parse(dataUrl, {
            download: true,
            dynamicTyping: true,
            complete: function(results) {
                callback(results.data);
            }
        })
        
    },
  }
    
}
</script>